// Music City Rodeo Theme JavaScript
(function() {
  'use strict';

  // Smooth scroll for anchor links
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        if (href === '#') return;

        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          const headerOffset = 100;
          const elementPosition = target.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  // Navbar scroll effect
  function initNavbarScroll() {
    const nav = document.querySelector('.nav');
    if (!nav) return;

    let lastScroll = 0;

    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset;

      if (currentScroll > 100) {
        nav.classList.add('nav-scrolled');
      } else {
        nav.classList.remove('nav-scrolled');
      }

      lastScroll = currentScroll;
    });
  }

  // Intersection Observer for animations
  function initScrollAnimations() {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    document.querySelectorAll('.event-card, .concert-card, .info-card').forEach(el => {
      observer.observe(el);
    });
  }

  // Product variant selector
  function initProductVariants() {
    const variantSelects = document.querySelectorAll('.product-option select');
    const variantInput = document.querySelector('.product-variant-select');

    if (!variantSelects.length || !variantInput) return;

    variantSelects.forEach(select => {
      select.addEventListener('change', function() {
        const options = Array.from(variantSelects).map(s => s.value);
        const optionString = options.join(' / ');

        Array.from(variantInput.options).forEach(option => {
          if (option.text === optionString) {
            variantInput.value = option.value;
          }
        });
      });
    });
  }

  // Cart quantity update
  function initCartQuantity() {
    const quantityInputs = document.querySelectorAll('.cart-item-quantity input');

    quantityInputs.forEach(input => {
      input.addEventListener('change', function() {
        const form = this.closest('form');
        if (form) {
          form.submit();
        }
      });
    });
  }

  // Initialize Lucide icons
  function initLucideIcons() {
    if (typeof lucide !== 'undefined') {
      lucide.createIcons();
    }
  }

  // DOM Ready
  document.addEventListener('DOMContentLoaded', function() {
    initSmoothScroll();
    initNavbarScroll();
    initScrollAnimations();
    initProductVariants();
    initCartQuantity();
    initLucideIcons();
  });

  // Reinitialize on Shopify section load (for Theme Editor)
  document.addEventListener('shopify:section:load', function() {
    initLucideIcons();
    initScrollAnimations();
  });
})();
